import React, { useContext, useState, useEffect } from 'react';
import { connect } from "react-redux"
import { Button, Icon, Item, Label, Message, Statistic, Segment, Grid, Pagination, Rating, Dimmer, Loader, Modal, Input } from 'semantic-ui-react';
//import InputText from "@components/FormInputCustomer/InputText/InputTextV2";
import { Link } from "react-router-dom";
import GlobalContext from '../../../contexts/GlobalContext';
import Utility from '../../../Utility';
import './BookingsFolder.css';
import AmountProvider from '../../Provider/AmountProvider';
import MomentCustomer from '../../MomentCustomer/MomentCustomer';
import API, {ErrorManagement, ResponseManagement} from "../../../API";
//import {SET_USER} from "@contexts/GlobalType";
import {toast} from "react-toastify";
//import ExtraDetails from "@components/Bookings/BookingsSupplements/ExtraDetails";
//import OptionDetails from "@components/Bookings/BookingsSupplements/OptionDetails";
import ModalTransition from "../../ModalTransition/ModalTransition";
//import {totalBookingFolderPrice} from "@store/booking";
//import Box from "@components/Box/Box";
//import { isNoSubstitutionTemplateLiteral } from 'typescript';

const mapProps = (state) => ({
  listInvoices: state.invoices.invoices,
  isModalHandleInvoicesOpen: state.modal.handleBookingFolderInvoices
});

const mapDispatch = (dispatch) => ({
  updateSelectedInvoices: dispatch.invoices.updateSelectedInvoices,
  handleInvoicesModal: dispatch.modal.handleModal
});

// const generateFile = (content, fileName) => {
//
//   let base64ToString = Buffer.from(obj, "base64").toString();
//   base64ToString = JSON.parse(base64ToString);
//
// };

/**
 *
 * @param {bookings, select, rating} props
 */
function BookingFolder(props) {

  const [globalContext] = useContext(GlobalContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [bookings, setBookings] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loaderMailButton, setLoaderMailButton] = useState(false);
  const [inputMailValue, setInputMailValue] = useState(globalContext.user.mail);
  const [selectedBookingFolder, setSelectedBookingFolder] = useState({});
  const [pdfInvoicesBase64, setPdfInvoicesBase64] = useState("");


  const maxPerPage = 5;
  const [showMultiEtabState, setShowMultiEtabState] = useState(false);
  //const [villeEtabState, setVilleEtabState] = useState("");

  let timeout = null;

  useEffect(() => {
    return () => {
      clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    if (props.select !== 'all'){
      if (props.select === 'future') {
        setBookings(props.bookings.filter( (booking) => booking.state === props.select || booking.state === 'enOption' || booking.state === 'pending' ))
      }
      else{
        setBookings(props.bookings.filter(booking => booking.state === props.select))
      }

    } else {
      setBookings(props.bookings)
    }

    setCurrentPage(1);

    if ( globalContext.espaceClientByOrga && Object.keys(globalContext.establishmentCollection).length > 0 ) {
      setShowMultiEtabState(true);
    }

  }, [props.bookings, props.select]);

  useEffect(() => {
    setTotalPage(Math.ceil(bookings.length / maxPerPage));
  }, [bookings])

  const getBookings = () => {
    let bookingsTab = [];
    // const status = {
    //   active: 'Active',
    //   cancel: globalContext.translations.bookingStatusCancelled,
    //   passed: globalContext.translations.bookingStatusPassed
    // }

    if (Object.entries(bookings).length > 0) {
      bookingsTab = bookings.map(booking => {
        const averageRating = props.rating.filter(rating => parseInt(rating.bookingFolderId) === parseInt(booking.id));
        const statusData = Utility.getStatusBooking(booking.state, globalContext.translations);
        const tradPrechecking = globalContext.translations.prechecking;
        let labelPrechecking = tradPrechecking.length > 0 ? Utility.ucFirst(tradPrechecking) : "";
        let haveBookingFuture = false;
        for (let folderId in props.haveBookingFuture) {
          if (props.haveBookingFuture[booking.id] === true) haveBookingFuture = true;
        }

        const tabFilterInvoices = props.listInvoices.filter(invoice => {
          return invoice.bookingFolderId == booking.id;
        });
        const folderInvoicesObj = tabFilterInvoices[0];

        let cityBook = "";
        let langIso = localStorage.getItem('lang');
        if (langIso === 'EN') {
          langIso = 'UK';
        }
        let filteredObjLang = {};
        if (globalContext?.languages !== undefined) {
          filteredObjLang = globalContext.languages.find(objLang => {
            return objLang.iso === langIso
          });
        }
        let langBe = Object.keys(filteredObjLang).length > 0 ? filteredObjLang.name : langIso;
        let linkBe = ``;
        let bookingEngineLinkProps = {};
        let etabTemp = ``;
        if( typeof globalContext.establishmentCollection[booking.establishmentId] != "undefined"){
          etabTemp = globalContext.establishmentCollection[booking.establishmentId]

          // city booking
          cityBook = etabTemp?.city+" - "+etabTemp?.zipCode;

          // lien be
          if( etabTemp?.customLinkBe != '' && typeof etabTemp?.customLinkBe !== "undefined" ){
            linkBe = `${etabTemp?.customLinkBe}`;
          }
          else{
            linkBe = Utility.getBookingEngineUrl(etabTemp?.bookingEngineId, langBe);
            bookingEngineLinkProps = Utility.getBookingEngineLinkProps(etabTemp?.bookingEngineId, linkBe);
          }
        }
        return (
          <Item key={booking.id}>
            <Item.Image size="medium" src={Utility.imageExists(booking.photo)} />
            <Item.Content className="d-flex flex-d-col">
              <Item.Header as="div" className="d-flex justify-content-between p-1">
                <div>
                  <p>{globalContext.translations.bookingEspaceClient} N°{booking.number} - <i>{etabTemp?.name}</i></p>
                </div>
                <div>
                  <Statistic.Group size="mini">
                    <Statistic>
                      <Statistic.Value>
                        {
                          // total dossier
                          booking?.noteSecondaire ?
                          <AmountProvider amount={booking.totalExtraPresta} currency={booking.currency} />
                          :
                          <AmountProvider amount={booking.servicesTotalAmount} currency={booking.currency} />
                        }
                      </Statistic.Value>
                    </Statistic>
                  </Statistic.Group>
                </div>
              </Item.Header>
              {/* <Item.Meta>
                      <span className="cinema">{status[booking.status] ? status[booking.status] : status.active}</span>
                  </Item.Meta> */}
              <Item.Extra>
                <Grid style={{ height: '100%' }} columns="equal">
                  <div >
                    <Label size="tiny" color={statusData.color}>{statusData.status}</Label>
                    {
                      showMultiEtabState ?
                      <Label size="tiny">
                        <Icon name='map marker alternate' color="blue" />
                        {cityBook}
                      </Label>
                      : ""
                    }
                  </div>
                  <Grid.Row>
                    {
                      ( booking.state == "passed" && averageRating[0].averageRate > 0 && globalContext.displayControl.OpinionFormRating)
                      ?
                          <Grid.Column className="mb-3" mobile={16} computer={16}>
                            <Rating defaultRating={props.select === "passed" || props.select === "all" ? averageRating.length > 0 ? averageRating[0].averageRate : 0 : 0} maxRating={5} disabled />
                          </Grid.Column>
                      : ""
                    }
                    <Grid.Column className="mb-3" mobile={16} computer={8}>
                      <Label as="span" content={<MomentCustomer format="DD MMM YYYY">{booking.arrivalDate}</MomentCustomer>} />
                        <Icon name="long arrow alternate right" size="large" />
                      <Label as="span" content={<MomentCustomer format="DD MMM YYYY">{booking.departureDate}</MomentCustomer>} />
                    </Grid.Column>
                    <Grid.Column className="mb-3" mobile={16} computer={6}>
                      <Label icon="hotel" content={booking.roomTotal} />
                      <Label icon="male" content={booking.paxTotal} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Item.Extra>
              <div style={{margin: 'auto 0 0 0'}} className="booking_card_action_container">
                <Button
                  as="a" target="_blank" href={linkBe} {...bookingEngineLinkProps}
                  className="showBe mt_mobile"
                  content={globalContext.translations.addBooking}
                  size='mini'
                  color='green'
                  /*compact*/
                  icon='cart'
                  labelPosition='left'
                  /*fluid*/
                />

                {

                  globalContext.displayControl.show_invoice && typeof folderInvoicesObj === "object" && Object.keys(folderInvoicesObj).length > 0 ?
                    <Button
                      className="custom_btn_invoices mt_mobile"
                      basic
                      size='mini'
                      color="red"
                      labelPosition='left'
                      icon="file pdf outline"
                      content={globalContext.translations.handleInvoices}
                      onClick={() => {
                        props.handleInvoicesModal({handleBookingFolderInvoices: true});
                        setSelectedBookingFolder(booking);
                      }}
                    />
                    :
                    ''
                }

                <Link to={{
                  pathname: `${Utility.getUrlBaseName()}/bookings/${booking.id}`,
                  state: { folderId: booking.id, folderNumber: booking.number }
                }}>
                  <Button
                      primary
                      size="mini"
                      floated="right"
                      content={globalContext.translations.details}
                      icon="right chevron"
                      labelPosition="right"
                      className="mt_mobile"
                  />
                </Link>
                {globalContext.displayControl.earlyCheckInForm && haveBookingFuture ?
                    <Link to={{
                      pathname: `${Utility.getUrlBaseName()}/checkin/${booking.id}`,
                      state: { folderId: booking.id, folderNumber: booking.number }
                    }}>
                      <Button
                          primary
                          floated="right"
                          size="mini"
                          content={labelPrechecking}
                          icon="right chevron"
                          labelPosition="right"
                          className="mt_mobile"
                      />
                    </Link>
                    : null
                }
              </div>
            </Item.Content>
          </Item>
        )
      })
    } else {
      return false
    }

    return bookingsTab;
  }

  const getContent = () => {
    const bookingsValue = getBookings();
    const bookingsFiltred = Utility.getPaginationData(bookingsValue, maxPerPage, totalPage);
    return !bookingsFiltred[currentPage] ? <Message>{globalContext.translations.noData}</Message> : <Segment><Item.Group divided>{bookingsFiltred[currentPage]}</Item.Group></Segment>
  }

  const getModal = () => {
    const tabFilterInvoices = props.listInvoices.filter(invoice => {
      return invoice.bookingFolderId == selectedBookingFolder.id;
    });

    const folderInvoicesObj = tabFilterInvoices.length > 0 ? tabFilterInvoices[0] : {};

    return (
      <>
      { globalContext.displayControl.show_invoice
      && typeof folderInvoicesObj === 'object' && Object.keys(folderInvoicesObj).length > 0
      ?
        <ModalTransition
          open={props.isModalHandleInvoicesOpen}
          handleClose={() => {
            props.handleInvoicesModal({handleBookingFolderInvoices: false})
            setPdfInvoicesBase64("");
          }}
          closeOnDimmerClick={false}
          size={pdfInvoicesBase64.length > 0 ? "fullscreen" : "tiny"}
          header={globalContext.translations.handleInvoices}
          isForIframe={pdfInvoicesBase64.length > 0}
          style={{height: pdfInvoicesBase64.length > 0 ? "94%" : ""}}
          content={
            <>
            { pdfInvoicesBase64.length > 0 ?
              /*<iframe
                style={{
                  width: "100%",
                  height: "100%",
                  borderStyle: "none"
                }}

                className="iframe_pdf"
                src={`data:application/pdf;base64,${
                  pdfInvoicesBase64
                }`}
              />*/
              <object type="application/pdf"
                  data={`data:application/pdf;base64,${
                    pdfInvoicesBase64
                  }`}
                  width="100%"
                  height="100%">
              </object>
                :
              <Modal.Content>
                <div className="modal_invoices_content_row">
                  <span>{globalContext.translations.downloadAllInvoices}</span>
                  <Button
                    icon
                    basic
                    primary
                    size="mini"
                    onClick={() => handleDownloadInvoices(selectedBookingFolder.establishmentId, folderInvoicesObj)}
                  >
                    <Icon
                      name="download"
                    />
                  </Button>
                </div>

                <div className="mt-2 modal_invoices_content_row">
                  <div>
                    <span style={{marginRight: "10px"}}>{globalContext.translations.sendMailAllInvoices}</span>
                    <Input
                      className="modal_invoices_input_mail"
                      size="mini"
                      onChange={handleInputMailValue}
                      defaultValue={inputMailValue}
                    />
                  </div>


                  <Button
                    icon
                    disabled={loaderMailButton}
                    loading={loaderMailButton}
                    primary
                    basic
                    size="mini"
                    onClick={() => handleSendInvoices(selectedBookingFolder.establishmentId, folderInvoicesObj)}
                  >
                    <Icon name="paper plane" />
                  </Button>
                </div>
              </Modal.Content>
            }
            </>
          }
          />
        :
        ''
      }
      </>
    );
  }

  const handleChangePage = (ev, el) => {
    setLoader(true);

    timeout = setTimeout(() => {
      setCurrentPage(el.activePage)
      setLoader(false);
      window.scrollTo({top:0})
    }, 200)

  }

  const handleDownloadInvoices = (bookingForlderEstablishmentId, folderInvoices) => {
    let dataToSend = new URLSearchParams({
      establishmentId: bookingForlderEstablishmentId,
      bookingFolderId: folderInvoices.bookingFolderId,
      invoices: JSON.stringify(folderInvoices)
    });

    API.post(Utility.getUrlAjax() + '/base64InvoicesPdf', dataToSend)
      .then(response => {
        ResponseManagement(response,
          () => {
            setPdfInvoicesBase64(response.data.data);
          },
          () => {
            toast.error(globalContext.translations[response.data.message])
          }
        );
      })
      .catch(error => {
        console.error("error",error)
        ErrorManagement(error, () => { });
      })
  }

  const handleSendInvoices = (bookingForlderEstablishmentId, folderInvoices) => {
    let dataToSend = new URLSearchParams({
      establishmentId: bookingForlderEstablishmentId,
      bookingFolderId: folderInvoices.bookingFolderId,
      email: inputMailValue,
      invoices: JSON.stringify(folderInvoices)
    });

    setLoaderMailButton(true);
    API.post(Utility.getUrlAjax() + '/sendMailBookingFolderInvoices', dataToSend)
      .then(response => {
        ResponseManagement(response,
          () => {
            if (response.data.success) {
              toast.success(globalContext.translations[response.data.message]);
              props.handleInvoicesModal({handleBookingFolderInvoices: false})
            }
          },
          () => {
            toast.error(globalContext.translations[response.data.message])
          }
        );
      })
      .catch(error => {
        console.error("error",error)
        ErrorManagement(error, () => { });
      })
      .finally(() => {
        setLoaderMailButton(false);
      })

  }

  const handleInputMailValue = (e, data) => {
    if (data?.value) {
      setInputMailValue(data.value)
    }
  }

  return (
    <div>
      <Dimmer active={loader} inverted>
        <Loader>{globalContext.translations.loading}</Loader>
      </Dimmer>
      {getContent()}
      {totalPage > 1 &&
        <Pagination
          onPageChange={handleChangePage}
          floated="right"
          className="mb-5"
          defaultActivePage={currentPage}
          ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
          prevItem={{ content: <Icon name="angle left" />, icon: true }}
          nextItem={{ content: <Icon name="angle right" />, icon: true }}
          totalPages={totalPage}
        />
      }
      {getModal()}
    </div>
  )
}

export default connect(mapProps, mapDispatch)(BookingFolder);
